import styled from "styled-components";

export const TableListRoot = styled.table`
  min-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;

  thead {
    th {
      position: sticky;
      top: 0;
      z-index: 1;
      font-family: "Open Sans";
      font-weight: 600;
      font-size: 13px;
      color: var(--snow);
      padding: 8px 0 8px 24px;
      white-space: nowrap;
      background-color: var(--dark);

      &:first-child {
        max-width: 200px;
      }

      &:last-child {
        width: 24px;
        padding: 0;
      }
    }
  }

  tbody {
    button {
      opacity: 0;
      width: 24px;
      height: 24px;
    }

    tr {
      &:hover,
      &.active {
        background-color: #302f45;
        border-radius: 2px;

        [data-options] {
          visibility: visible;
        }

        td {
          color: var(--snow);
        }

        button {
          opacity: 1;
          color: var(--snow);
          &:hover {
            color: var(--ebony);
          }
        }

        .d-status {
          color: #ff5f53;
          background-color: #4c2d3c;
        }
      }

      td {
        font-family: var(--ff-mono), monospace;
        font-weight: 600;
        font-size: 12px;
        padding-left: 24px;
        color: var(--periwinkle-grey);
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

        &:first-child {
          max-width: 200px;
        }

        &:last-child {
          width: 24px;
          padding: 0;
          display: flex;
          align-items: center;
        }
      }
    }

    .d-status {
      color: #fb3728;
      background-color: #3c1d2c;
    }
  }
`;

export const SortByHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;
